import { GetStreamService } from '@/app/services/get-stream/get-stream.service';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Channel } from 'stream-chat';

@Component({
  selector: 'dbv2-unread-messages',
  imports: [RouterLink],
  templateUrl: './unread-messages.html',
  styleUrl: './unread-messages.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnreadMessages {

  /** Services */
  public getStreamService = inject(GetStreamService);
  private router = inject(Router);
  /** Services - END */

  /** Placeholder rows rendered while channels load. */
  protected readonly skeletonRows = [0, 1, 2, 3];

  /** Opens the selected channel in the inbox. */
  async openChannel(channel: unknown): Promise<void> {
    await this.getStreamService.openChannel(channel as Channel);
    void this.router.navigate(['/inbox']);
  }

  /** Re-runs the channel load after a failure; clears the error state on success. */
  async retry(): Promise<void> {
    await this.getStreamService.reloadStreamChat('all');
  }

}
